import React from 'react';

import { Stream } from '$partials/modules';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/pages.d.ts').StaffListingPage}
 */
const StaffListingPage = (props) => {
    const page = props.data.page;

    return (
        <main className='container'>
            <div className='col-12 flex flex-wrap mb7 md-mb9'>
                <div className='col-12'>
                    <p className='type-style-5 pb5 md-pb4'>
                        {page.pageLabel}
                    </p>
                </div>
                <div className='col-12 sm-col-6 md-col-5 pb5 sm-pb0'>
                    <h1 className='type-style-1'>
                        {page.title}
                    </h1>
                </div>
                <div className='hide md-show col-1'/>
                <div
                    className='col-12 sm-col-6 md-col-4 rich-text type-style-3'
                    dangerouslySetInnerHTML={{__html: page.standfirst}}/>
            </div>

            {/* modules */}
            <Stream
                modules={page.modules}
                namespace='staff-listing-page' />
        </main>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default StaffListingPage ;
